import React from 'react';
interface AuditType {
    index: number;
    results: any[];
    name: string;
    handleHitSelect?: any;
    handleVisClick: any;
}

const ResultsRow: React.FC<AuditType> = ({ index, results, handleHitSelect, name, handleVisClick }) => {
  return (
    <>
      <div className='view-history-body-frame-row'>
        <div className='view-history-body-frame-row-name' onClick={() => handleHitSelect(results, name)}>
          <div className='view-history-body-frame-row-date-text-names'>
            {name}
          </div>
        </div>
        <div className='view-history-body-frame-row-dates'>
          <div className='view-history-body-frame-row-date-text'>
            {results?.length}
          </div>
        </div>
        <div className='view-history-body-frame-row-dates'>
          <div className='view-history-body-frame-row-date-texts'>
            <div>0</div>
          </div>
        </div>
        <div className='view-history-body-frame-row-icon' onClick={() => handleVisClick(index)}>
          <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none' cursor={'pointer'}>
            <path d='M1.81509 9.53488C1.71295 9.37315 1.66188 9.29229 1.63329 9.16756C1.61182 9.07387 1.61182 8.92613 1.63329 8.83244C1.66188 8.70771 1.71295 8.62685 1.81509 8.46512C2.65915 7.12863 5.17155 3.75 9.0003 3.75C12.8291 3.75 15.3415 7.12863 16.1855 8.46512C16.2877 8.62685 16.3387 8.70771 16.3673 8.83244C16.3888 8.92613 16.3888 9.07387 16.3673 9.16756C16.3387 9.29229 16.2877 9.37315 16.1855 9.53488C15.3415 10.8714 12.8291 14.25 9.0003 14.25C5.17155 14.25 2.65915 10.8714 1.81509 9.53488Z' stroke='#EFF1F6' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
            <path d='M9.0003 11.25C10.2429 11.25 11.2503 10.2426 11.2503 9C11.2503 7.75736 10.2429 6.75 9.0003 6.75C7.75766 6.75 6.7503 7.75736 6.7503 9C6.7503 10.2426 7.75766 11.25 9.0003 11.25Z' stroke='#EFF1F6' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
          </svg>
        </div>
      </div>
    </>
  );
};

export default ResultsRow;
